import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

declare var grapesjs: any;

@Component({
  selector: 'app-page-generator',
  templateUrl: './page-generator.component.html',
  styleUrls: ['./page-generator.component.scss'],
})
export class PageGeneratorComponent implements OnInit, OnChanges {
  @Input() html: string = '';
  @Output() htmlChange = new EventEmitter<string>();
  editor: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.html.currentValue && this.editor)
      this.editor.setComponents(this.html);
  }

  ngOnInit(): void {
    this.editor = grapesjs.init({
      container: '#gjs',
      height: '300px',
      width: 'auto',
      plugins: ['gjs-preset-newsletter'],
      components: this.html,
      storageManager: false,
    });
    this.editor.on('change:changesCount', (e: any) => {
      this.htmlChange.emit(this.editor.runCommand('gjs-get-inlined-html'));
    });
  }
}
